// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"934321b5620932b66b1a","691":"c5bd74028e910cfbe63b","731":"0619f90be4c725921d96","843":"8c42b63eaccf365a854c"}[chunkId] + ".js";
};